import productFilter from '../modules/Filters/product_ordering';
import '../modules/nice_select'

productFilter();

const toggleButtons = document.querySelectorAll(".more");
const lists = document.querySelectorAll(".filter__list");
const more = document.querySelectorAll(".more-img");
const less = document.querySelectorAll(".less-img");

toggleButtons.forEach((button, index) => {
    const list = lists[index];
    const btn = toggleButtons[index];
  button.addEventListener("click", function() {
    btn.classList.toggle("active");
    list.classList.toggle("active");
  });
});


$(document).ready(function () {
    $('#filter-options').niceSelect();
});


const socialIcons = document.getElementById('component--social-icons')
socialIcons.style.display = 'none'

const btnMobile = document.querySelector('.btn-mobile-filter');
const filterMobile = document.querySelector('.filterProduct');
const btnBack = document.querySelector('.filterProduct__back');

let mobileFiltertl = gsap.timeline({paused: true});

mobileFiltertl.to(filterMobile, {
    duration: 0.2,
    position: 'fixed',
    left: 0,
    display: 'block',
})
    .to(filterMobile, {
        opacity: 1,
    })

btnMobile.addEventListener('click', () => {
    mobileFiltertl.play();
})
btnBack.addEventListener('click', () => {
    mobileFiltertl.reverse();
})
